export default __webpack_public_path__ + "static/media/fuguo.13368a0e.png";